export default function userHasEntityPermission(userRoles, entity, enityId, permission) {
  const entityRoles = userRoles[`${entity}:${enityId}`] || [];

  return entityRoles.reduce((roleHasPermission, currentRole) => {
    if (roleHasPermission) return true;
    for (let i = 0; i < currentRole.permissions.length; i++) {
      if (currentRole.permissions[i].name === permission) return true;
    }
    return false;
  }, false);
}
